<div class="ajax-loading">
    <div class="loading-icon"></div>
</div>
<section class="page-title">
    <h1>Configuration Groups</h1>
    <div class="employee-code"><button mat-raised-button mat-raised-button color="primary" class="oms-btn pull-right"
        (click)="openGroupDialog(configurationGroupModel)"> Add Group </button></div>
</section>
<mat-card class="card-white mb-4">
    <mat-card-title class="mb-0">
        <div class="card-white-title mb-0 cursor-pointer" [class.advanceSearchFilter]="isAdvanceSearchFilter"
            (click)="onDisplayFilter(null)">
            <div class="card-user-name">Advance Search or Filter </div>
            <div class="office-hours">
                <a class="box-arrow" (click)="onDisplayFilter($event)" href="javascript:void(0);">&nbsp;</a>
            </div>
        </div>
    </mat-card-title>
    <mat-card-content [hidden]="!isAdvanceSearchFilter" class="mt-3">
        <div class="example-form">
            <div class="form-for-advance-search">
                <div class="row">
                    <div class="col-sm-12 col-md-6 col-lg-3">
                        <mat-form-field class="example-full-width">
                            <input matInput [(ngModel)]="filterKey" (keyup)="applyFilter($event.target.value)"
                                placeholder="Filter">
                            <button *ngIf="filterKey" matSuffix mat-icon-button aria-label="Clear" (click)="filterKey='';applyFilter('')">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                </div>
                
            </div>
        </div>
    </mat-card-content>
</mat-card>
<mat-card class="card-white matcardheight">
    <mat-card-content>
        <div *ngIf="sortedGroupList.length > 0" class="stiky-table-container ps-table">
            <table class="list-table" mat-table matSort (matSortChange)="sortGroups($event)"
                matSortActive="description" matSortDirection="asc" [matSortDisableClear]="true"
                [dataSource]="dataSource">
                <ng-container matColumnDef="productCode">
                    <th mat-header-cell mat-sort-header="productCode" *matHeaderCellDef> Product Code </th>
                    <td mat-cell *matCellDef="let element">
                        <span>{{element.productCode}}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="groupName">
                    <th mat-header-cell mat-sort-header="groupName" *matHeaderCellDef> Product Name </th>
                    <td mat-cell *matCellDef="let element">
                        <span>{{element.groupName}}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>Actions</th>
                    <td mat-cell *matCellDef="let element">
                        <ul class="action-items">
                            <li class="view-link">
                                <a title="Manage Configuration" class="me-3" routerLink="/configurationdetails" [queryParams]="{productCode:element.productCode}"><i class="fa fa-cogs"></i></a>
                                <a (click)="openGroupDialog(element)" href="javascript:void(0)"><i
                                    class="fa fa-pencil"></i></a>
                            </li>
                        </ul>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
        <mat-paginator #paginator [pageSize]="pageSize" [showFirstLastButtons]="true" [pageSizeOptions]="[5, 10, 20]">
        </mat-paginator>
        <div *ngIf="sortedGroupList.length == 0" class="no-record-found text-center">No record found.</div>
    </mat-card-content>
</mat-card>